import { Button, Grid, TextField, Typography, FormControl, RadioGroup, FormControlLabel, Checkbox, FormHelperText, Radio } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { AuthenticationService } from "../../../services/authentication/AuthenticationService";
import { useEffect, useState } from "react";
import Layout from "../../Layout";
import { useNavigate } from "react-router-dom";



/**
 * Code inspired by the following tutorial:
 * https://www.youtube.com/watch?v=gimKHlOSN0g
 */

const Signup = () => {
    const navigateTo = useNavigate();
    const paperStyle = { padding: 20, margin: "0 auto" }
    const headerStyle = { margin: 0 }
    const avatarStyle = { backgroundColor: '#1bbd7e' }

    // Email
    const [email, setEmail] = useState<string>("");
    const [emailError, setEmailError] = useState<string>("");

    function handleEmailFocusLoss() {
        if (email.length === 0) { setEmailError("Vous devez spécifier une adresse courriel."); }
        else if (!email.includes('@') || !email.includes('.')) {
            setEmailError("L'adresse courriel est invalide.");
        } else {
            setEmailError("");
        }
    }

    // name
    const [name, setName] = useState<string>("");
    const [nameError, setNameError] = useState<string>("");

    function handleNameFocusLoss() {
        if (name.length === 0) { setNameError("Vous devez spécifier un nom."); }
        else {
            setNameError("");
        }
    }

        // name
    const [firstname, setFirstName] = useState<string>("");
    const [firstNameError, setFirstNameError] = useState<string>("");

    function handleFirstNameFocusLoss() {
        if (firstname.length === 0) { setFirstNameError("Vous devez spécifier un prénom."); }
        else {
            setFirstNameError("");
        }
    }

    // Password
    const [password, setPassword] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string>("");

    function handlePasswordFocusLoss() {
        if (password.length < 6) {
            setPasswordError("Votre mot de passe doit contenir au moins 6 caractères.");
        } else {
            setPasswordError("");
        }
    }

    // Repeat password
    const [repeatPassword, setRepeatPassword] = useState<string>("");
    const [repeatPasswordError, setRepeatPasswordError] = useState<string>("");

    function handleRepeatPasswordLoss() {
        if (repeatPassword.length === 0) {
            setRepeatPasswordError("Ce champ ne peut être vide.");
        } else if (repeatPassword !== password) {
            setRepeatPasswordError("Les deux mots de passe sont différents.");
        } else {
            setRepeatPasswordError("");
        }
    }

    const [consent, setConsent] = useState<boolean|undefined>(undefined);

    const [consentError, setconsentError] = useState<string>("");

    useEffect(()=>{
        if (!consent && consent!=undefined) {
            setconsentError("Les cases doivent etre coche");
        } else {
            setconsentError("");
        }
    },[consent])

    const onSignupClick = async () => {
        handleEmailFocusLoss();
        handleNameFocusLoss();
        handleFirstNameFocusLoss();
        handlePasswordFocusLoss();
        handleRepeatPasswordLoss();
        console.log(consent, consentError)
        if (
            email.length > 0 &&
            password.length > 0 &&
            name.length > 0 &&
            firstname.length > 0 &&
            emailError.length === 0 &&
            passwordError.length === 0 &&
            nameError.length === 0 &&
            firstNameError.length === 0 &&
            consent &&
            consentError.length===0
        ) {
            const success = await AuthenticationService.signUp(email, name, firstname, password);
            if(success){
                
                setTimeout(()=>{
                    navigateTo("/login");
                },500)
            }
        }
    }

    const handleChange = (event:any) => {
        console.log((event.target as HTMLInputElement).value=="oui")
        setConsent((event.target as HTMLInputElement).value=="oui");
        // handleConsentLoss()
    };

    return (
        <Layout>
    
            <Grid className="container-grande-marge"> 
                <Grid className="container-form">
                    <h2 className="serious-title" >S’inscrire</h2>
                    <Typography variant='caption' gutterBottom>Veuillez remplir les champs suivants.</Typography>
                    <form>
                        <TextField
                            className="serious-input"
                            fullWidth
                            error={nameError.length > 0}
                            value={name}
                            helperText={nameError}
                            onChange={(e) => { setName(e.target.value); }}
                            onBlur={handleNameFocusLoss}
                            label='Nom'
                            variant="outlined"
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                    shrink: true,
                                }} />
                        <TextField
                            className="serious-input"
                            fullWidth
                            error={firstNameError.length > 0}
                            value={firstname}
                            helperText={firstNameError}
                            onChange={(e) => { setFirstName(e.target.value); }}
                            onBlur={handleFirstNameFocusLoss}
                            label='Prénom'
                            variant="outlined"
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                    shrink: true,
                                }} />
                        <TextField
                            className="serious-input"
                            fullWidth
                            error={emailError.length > 0}
                            helperText={emailError}
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); }}
                            onBlur={handleEmailFocusLoss}
                            label='Courriel'
                            variant="outlined"
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                    shrink: true,
                                }} />

                        <TextField
                            className="serious-input"
                            fullWidth
                            error={passwordError.length > 0}
                            value={password}
                            helperText={passwordError}
                            type={"password"}
                            onChange={(e) => { setPassword(e.target.value); }}
                            onBlur={handlePasswordFocusLoss}
                            label='Mot de passe'
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                    shrink: true,
                                }} />

                        <TextField
                            className="serious-input"
                            fullWidth
                            error={repeatPasswordError.length > 0}
                            value={repeatPassword}
                            helperText={repeatPasswordError}
                            type={"password"}
                            onChange={(e) => { setRepeatPassword(e.target.value); }}
                            onBlur={handleRepeatPasswordLoss}
                            label='Confirmer le mot de passe'
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            InputLabelProps={{
                                    shrink: true,
                                }} />

                        <FormControl error={consentError.length > 0 }>
                                {/* <Typography sx={{color:"black"}}>Je confirme que je suis âgé.e de 18 ans ou plus.</Typography>  */}
                                <Typography sx={{color:"black"}}>Je confirme que je suis âgé.e de 18 ans ou plus et que j’habite un immeuble multi-logements au Québec.</Typography>
                                {/* <FormControlLabel value="accepte de participer au projet" control={<Radio />} label="Je confirme que j’ai lu et compris les informations présentées dans ce formulaire et en cliquant sur la case, je confirme que j’accepte de participer au projet." /> */}
                                {/* <FormControlLabel value="résumé des résultats" control={<Radio />} label="Je souhaite recevoir un résumé des résultats de cette recherche à la fin du projet." /> */}
                                <RadioGroup onChange={handleChange}>

                                    <FormControlLabel value={"oui"} control={<Radio />}  label="Oui" />
                                    <FormControlLabel value={"non"} control={<Radio />} label="Non" />
                                </RadioGroup>
                                
                            {consentError.length > 0 && (<FormHelperText>Désolée, vous n’êtes pas éligible à participer à cette étude, car vous ne remplissez pas toutes les conditions.</FormHelperText>)}
                        </FormControl>
                        
                        <Button onClick={onSignupClick} variant='contained' className="serious-btn" >S’inscrire</Button>
                    </form>
                </Grid>   
            </Grid>
        {/*
        <Grid>
            <Paper style={paperStyle}>
                <Grid>
                    <Avatar style={avatarStyle}>
                        <AddCircleOutlineIcon />
                    </Avatar>
                    <h2 style={headerStyle}>Nouvel utilisateur</h2>
                    <Typography variant='caption' gutterBottom>Veuillez remplir les champs suivants.</Typography>
                    <form>
                        <TextField
                            fullWidth
                            error={nameError.length > 0}
                            value={username}
                            helperText={nameError}
                            onChange={(e) => { setName(e.target.value); }}
                            onBlur={handleNameFocusLoss}
                            label='Nom'
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            placeholder="Saisissez votre nom." />

                        <TextField
                            fullWidth
                            error={emailError.length > 0}
                            helperText={emailError}
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); }}
                            onBlur={handleEmailFocusLoss}
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            label='Adresse courriel'
                            placeholder="Saisissez votre adresse courriel." />

                        <TextField
                            fullWidth
                            error={passwordError.length > 0}
                            value={password}
                            helperText={passwordError}
                            type={"password"}
                            onChange={(e) => { setPassword(e.target.value); }}
                            onBlur={handlePasswordFocusLoss}
                            label='Mot de passe'
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            placeholder="Saisissez votre mot de passe." />

                        <TextField
                            fullWidth
                            error={repeatPasswordError.length > 0}
                            value={repeatPassword}
                            helperText={repeatPasswordError}
                            type={"password"}
                            onChange={(e) => { setRepeatPassword(e.target.value); }}
                            onBlur={handleRepeatPasswordLoss}
                            label='Confirmer le mot de passe'
                            sx={{ "marginTop": ".5em", "marginBottom": ".5em" }}
                            placeholder="Confirmez le mot de passe." />

                        <Button onClick={onSignupClick} variant='contained' color='primary'>Créer un nouveau compte</Button>
                    </form>
                </Grid>
            </Paper>
        </Grid>*/}
        
        </Layout>
    );
};


export default Signup;
